//для мультиязычности
var url = window.location.href;
var common_path = "";
if (url.indexOf('/ru/') + 1) {
    common_path = '/ru/ajax/common.php'
} else {
    common_path = '/ajax/common.php'
}
export const APP = {
    'ajax_endpoint': common_path,
}
